module.exports = __webpack_public_path__ + "static/media/edit_constraints_classroom_settings.02999851.mov";